import cookies from 'js-cookie'
import * as constants from '../constants/constants'

const setToken = (token) => {
    cookies.set(constants.REACT_APP_AUTHENTICATE_TOKEN_NAME, token, {
        path: '/',
        domain: constants.REACT_APP_DOMAIN,
        expires: 1
    })
}

const setUserId = (userId) => {
    cookies.set(constants.REACT_APP_USER_ID_COOKIE_NAME, userId, {
        path: '/',
        domain: constants.REACT_APP_DOMAIN,
        expires: 1
    })
}

const setUserDetails = (userDetails) => {
    cookies.set(constants.REACT_APP_USER_DETAILS_COOKIE_NAME, JSON.stringify(userDetails), {
        path: '/',
        domain: constants.REACT_APP_DOMAIN,
        expires: 1
    })
}

const getToken = () => cookies.get(constants.REACT_APP_AUTHENTICATE_TOKEN_NAME)

const getUserId = () => cookies.get(constants.REACT_APP_USER_ID_COOKIE_NAME)

const getUserDetails = () => {
    try {
        const userDetails = cookies.get(constants.REACT_APP_USER_DETAILS_COOKIE_NAME)
        if (!userDetails) return null

        const parsedUserDetails = JSON.parse(userDetails)
        return parsedUserDetails
    } catch (error) {
        console.error('Error getting user details:', error)
        return null
    }
}


const deleteToken = () => {
    cookies.remove(constants.REACT_APP_AUTHENTICATE_TOKEN_NAME, {
        path: '/',
        domain: constants.REACT_APP_DOMAIN
    })
}

const deleteUserId = () => {
    cookies.remove(constants.REACT_APP_USER_ID_COOKIE_NAME, {
        path: '/',
        domain: constants.REACT_APP_DOMAIN
    })
}

const deleteUserDetails = () => {
    cookies.remove(constants.REACT_APP_USER_DETAILS_COOKIE_NAME, {
        path: '/',
        domain: constants.REACT_APP_DOMAIN
    })
}

const isUserLoggedIn = () => {
    if (!Boolean(getToken())) return false;
    const userDetails = getUserDetails();
    if (!userDetails) return false;
    return true;
}

const isUserAllowed = () => {
    if (!isUserLoggedIn()) return false;    
    const userDetails = getUserDetails();
    if (!userDetails) return false;

    const userRoles = userDetails.roleCodes;
    const allowedRolesSet = new Set(constants.ALLOWED_ROLES);

    return userRoles.some(role => allowedRolesSet.has(role));
}

const getLoginRoles = () => {
    const userDetails = getUserDetails()
    if (!userDetails) return []

    const roles = userDetails.roles
    return Array.isArray(roles) ? roles : []
}

const login = (data)=>{
    try {
        const { accessToken: token, crnId: userId } = data
        setToken(token);
        setUserId(userId);
        setUserDetails(data);
        localStorage.setItem("loggedInUserId", userId);
        return true;
    } catch (error) {
        console.error('Error logging in:', error)
        return false;
    }
}

const logout = () => {
    deleteToken()
    deleteUserId()
    deleteUserDetails()
    localStorage.removeItem("loggedInUserId")
}


const tokenUtils = {
    login,
    logout,
    setToken,
    setUserId,
    setUserDetails,
    getToken,
    getUserId,
    getUserDetails,
    getLoginRoles,
    deleteToken,
    deleteUserId,
    deleteUserDetails,
    isUserAllowed,
    isUserLoggedIn
}

export default tokenUtils;